import type { Metadata } from "next";
import AdminFaq from '@/Component/Admin/FAQ';

export const metadata: Metadata = {
    title: "FAQs | Connector Club",
    description: "",
};

const FaqPage = () => {
    return (
        <AdminFaq />
    );
}

export default FaqPage;
